import React, { useState, useEffect } from "react";
import { getAllProjects } from "../../../services/projectService";
import { API_URL } from "../../../config/api"; 

const ArrowLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
);

const ArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
);

export default function PropertyCategoryCarousel() {
  const [projects, setProjects] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(4);
  const [isMobile, setIsMobile] = useState(false);

  // Helper: Lấy ảnh đầu tiên từ field image (string JSON)


  // Lấy ảnh đầu tiên
  const getProjectImage = (item) => {
    if (!item.image) return "/no-image.jpg";
    let images = [];
    try {
      if (typeof item.image === "string") {
        const parsed = JSON.parse(item.image || "[]");
        if (Array.isArray(parsed)) images = parsed;
      } else if (Array.isArray(item.image)) {
        images = item.image;
      }
    } catch (err) {
      console.error("Lỗi parse project image:", err);
      images = [];
    }
    if (!images.length) return "/no-image.jpg";
    return images[0].startsWith("http") ? images[0] : `${API_URL}${images[0].trim()}`;
  };

  // Responsive
  useEffect(() => {
    const updateResponsive = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setItemsPerView(1);
        setIsMobile(true);
      } else if (width < 1024) {
        setItemsPerView(2);
        setIsMobile(true);
      } else {
        setItemsPerView(4);
        setIsMobile(false);
      }
    };
    updateResponsive();
    window.addEventListener("resize", updateResponsive);
    return () => window.removeEventListener("resize", updateResponsive);
  }, []);

  // Load 4 dự án mới nhất
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await getAllProjects({ page: 1, limit: 10 }); // truyền query params
        const latestProjects = data.projects.slice(0, 4); // lấy 4 dự án đầu
        setProjects(latestProjects);
      } catch (err) {
        console.error("Lỗi load dự án:", err);
      }
    };
    fetchProjects();
  }, []);


  // Auto slide cho mobile
  useEffect(() => {
    if (!isMobile) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % (projects.length - itemsPerView + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [isMobile, itemsPerView, projects]);

  if (!projects.length) return null;

  return (
    <div className="relative w-full">
      {/* Slides */}
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * (100 / itemsPerView)}%)` }}
        >
          {projects.map((item, index) => (
            <div
              key={index}
              className="px-2 py-4 flex-shrink-0"
              style={{ width: `${100 / itemsPerView}%` }}
            >
              <a
                href={item.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02] cursor-pointer group block"
              >
                <div
                  className="h-36 md:h-44 bg-cover bg-center flex items-end p-4 transition-all duration-300 group-hover:scale-105"
                  style={{ backgroundImage: `url(${getProjectImage(item)})` }}
                >
                  <div className="bg-black/30 backdrop-blur-sm rounded-lg p-2 group-hover:bg-black/50 transition-all">
                    <h4 className="font-semibold text-white text-lg drop-shadow-md">
                      {item.name}
                    </h4>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Arrows cho desktop */}
      {!isMobile && (
        <>
          <button
            onClick={() => setCurrentSlide((prev) => Math.max(prev - 1, 0))}
            className="absolute top-1/2 left-4 -translate-y-1/2 bg-white/80 hover:bg-white transition p-3 rounded-full shadow-lg"
          >
            <ArrowLeft />
          </button>
          <button
            onClick={() =>
              setCurrentSlide((prev) =>
                Math.min(prev + 1, projects.length - itemsPerView)
              )
            }
            className="absolute top-1/2 right-4 -translate-y-1/2 bg-white/80 hover:bg-white transition p-3 rounded-full shadow-lg"
          >
            <ArrowRight />
          </button>
        </>
      )}

      {/* Dots cho mobile */}
      {isMobile && (
        <div className="flex justify-center mt-4 space-x-2">
          {projects.map((_, index) => (
            <div
              key={index}
              className={`w-2 h-2 rounded-full transition-all ${index === currentSlide ? "bg-gray-800 scale-125" : "bg-gray-300"
                }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
